export default __webpack_public_path__ + "static/media/Background-13-01-22.c392d807.png";